import React from 'react';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { InquireModalContent } from '../TaskPublicityModal';
import { changeURLSearchArg } from '../../../utils/common';

import GlobalModalAction from '../../../module/common/GlobalModalBox/action';


const Header:React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { repairAccount } = useSelector((state: any) => state.global);

    const linkToMethodList = () => {
        if (window.location.hash.indexOf('taskPublicity') > -1) {
            return;
        }
        const search = changeURLSearchArg(window.location.search, 'timestamp', new Date().getTime() + '');
        if (repairAccount) {
           window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}${search}#/`;
        } else {
            window.location.href = `https://mail.163.com/register/index.htm?from=freeAcRepair`;
        }
    }

    const InquireAccountTask = () => {
        try {
            (window as any).mailStats.show('look_for_my_account_if_publicizing')
        } catch(e) {}
        dispatch({
            type: GlobalModalAction.UPDATE_GLOBAL_MODAL,
            playload: {
                title: '请选择并输入完整的验证信息来查询',
                content: <InquireModalContent /> ,
                show: true,
                extraClass: 'task-publicity-inquire-modal-wrapper'
            }
        })
    }
    
    return (
        <div className="app-header">
            <div className="content">
                <div className="logo" onClick={() => linkToMethodList()} ></div>
                {location && location.pathname.indexOf('taskPublicity') > -1 ? 
                    <span className="inquire-my-account" data-stats-key="look_for_my_account_if_publicizing" onClick={() => InquireAccountTask()}>查询我的账号是否被公示</span>:
                    <a className="link-to-help" data-stats-key="link-to-help" target="_blank" rel="noopener noreferrer" href="https://help.mail.163.com/faq.do?m=list&categoryID=219">帮助</a>}
            </div>
        </div>
    )
}

export default Header;
